export default __webpack_public_path__ + "static/media/Group_7476.61043e52.png";